import { render, staticRenderFns } from "./MilestoneGroupCreate.vue?vue&type=template&id=d93503bc&"
import script from "./MilestoneGroupCreate.vue?vue&type=script&lang=js&"
export * from "./MilestoneGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports